/**
 * index.ts - Data management preference modules
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export { distillrModule } from './distillr';
export { searchrModule } from './searchr';

import { distillrModule } from './distillr';
import { searchrModule } from './searchr';

export const dataModules = [
  distillrModule,
  searchrModule
];

export default dataModules;
